import { Component, ContentChild, EventEmitter, HostListener, Input, OnInit, Output, TemplateRef,
    ChangeDetectionStrategy
} from '@angular/core';

export type OptionsContentLayoutMobileMode = 'overlay' | 'push';

@Component({
    selector: 'sm-options-content-layout',
    templateUrl: './options-content-layout.component.html',
    styleUrl: './options-content-layout.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class OptionsContentLayoutComponent implements OnInit {

    @Input()
    optionsWidthClass = 'width300';

    @Input()
    optionsStyleClass = '';

    @Input()
    contentStyleClass = '';

    @Input()
    collapsible = true;

    @Input()
    mobileMode: OptionsContentLayoutMobileMode = 'overlay';

    @Input()
    mobileBreakpoint = 767;

    @Input()
    showToggleButton = true;

    @Input()
    toggleIcon = 'fas fa-sliders-h';

    @Input()
    toggleTooltip = 'Optionen';

    @Input()
    collapsedBarWidth = '2.75rem';

    @Input()
    closeOnBackdropClick = true;

    @Input()
    closeOnMobileContentClick = false;

    @Input()
    optionsVisible = false;

    @Output()
    optionsVisibleChange = new EventEmitter<boolean>();

    @ContentChild('options')
    options: TemplateRef<any>;

    @ContentChild('content')
    content: TemplateRef<any>;

    mobile = false;

    ngOnInit(): void {
        this.updateMobile();
    }

    @HostListener('window:resize')
    updateMobile(): void {
        this.mobile = window.innerWidth <= this.mobileBreakpoint;
    }

    get canCollapse(): boolean {
        return this.collapsible && this.mobile;
    }

    get inlineOptionsVisible(): boolean {
        return !this.canCollapse ||
            this.mobileMode == 'push' && this.optionsVisible;
    }

    get overlayOptionsVisible(): boolean {
        return this.canCollapse && this.mobileMode == 'overlay' && this.optionsVisible;
    }

    get toggleVisible(): boolean {
        return this.showToggleButton && this.canCollapse;
    }

    toggleOptions(): void {
        this.setOptionsVisible(!this.optionsVisible);
    }

    closeOptions(): void {
        this.setOptionsVisible(false);
    }

    contentClicked(): void {
        if (this.closeOnMobileContentClick && this.canCollapse && this.optionsVisible) {
            this.closeOptions();
        }
    }

    setOptionsVisible(value: boolean): void {
        this.optionsVisible = value;
        this.optionsVisibleChange.emit(value);
    }
}
